import React, { useState } from "react";
import Header from "../Header.js";
import Footer from "../Footer.js";
import ButtonRow from "../ButtonRow.js";
import {
  Box,
  Button,
  ButtonGroup,
  Container,
  Typography,
  CardHeader,
  TextField,
  InputAdornment,
  Divider,
} from "@mui/material";
import { Search, FilterList, Add } from "@mui/icons-material";
import CustomersTable from "./CustomersTable.js";
import CustomersFormDialog from "./CustomersFormDialog.js";
import ClientDetails from "../ClientDetails/ClientDetails.js";
import ButtonOne from "../../common/normal-button.jsx";
import TableSearchInput from "../../components/TableSearchInput.js"
import ButtonTwo from "../../common/dashboard-button.jsx";
import BackButton from "../../common/back-button.jsx";
import AppDatePicker from "../../common/app-date-picker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const CustomersHome = (props) => {
  const [searchValue, setSearchValue] = useState("");
  const [charCount, setCharCount] = useState(0);
  const [clientModal, setClientModal] = useState({
    isOpen: false,
  });
  const [selectedClient, setSelectedClient] = useState(null);
  const [currentView, setCurrentView] = useState("table");
  const [selectedClientCode, setSelectedClientCode] = useState(null);

  const userRole = localStorage.getItem("role");

  const permissions = localStorage.getItem("permissions") || [];
  const clientMasterReadPermission = "client_master.view";
  const clientMasterAddPermission = "client_master.add";
  const clientMasterEditPermission = "client_master.edit";

  const hasReadPermission = permissions.includes(clientMasterReadPermission);
  const hasAddPermission = permissions.includes(clientMasterAddPermission);
  const hasEditPermission = permissions.includes(clientMasterEditPermission);

  const updateSearchValue = (value) => {
    if (value.length > 50) {
      return;
    }
    setSearchValue(value);
    setCharCount(value.length);
  };

  const URL =
    process.env.NODE_ENV === "production" ? "api" : `http://localhost:8000/api`;

  const handlePopupOpen = (param, data) => {
    let popupType = param;
    setClientModal({ isOpen: true, popupType: popupType, data: data });
    setSelectedClient(data);
  };

  const handleModalChanges = (changes) => {
    setClientModal(changes);
  };

  const handleViewClient = (clientCode) => {
    setSelectedClientCode(clientCode);
    setCurrentView("details");
  };

  const handleBackToTable = () => {
    setCurrentView("table");
    setSelectedClientCode(null);
  };
  const [filters, setFilters] = useState({
  updatedDate: "",
});

  return (
    <div>
      <Container maxWidth={false} sx={{ mt: 2}}>
        {currentView === "table" ? (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: { xs: "wrap", md: "nowrap" },
                mb: 2,
              }}
            >
              {hasAddPermission && (
                <ButtonOne
                  startIcon={<Add />}
                  className={``}
                  onClick={() => handlePopupOpen("Add", null)}
                  variant="contained"
                >
                  <Typography variant="body1">Add</Typography>
                </ButtonOne>
              )}
              <TableSearchInput
                searchQuery={searchValue}
                onSearchChange={(e) => updateSearchValue(e.target.value)}
                tooltip="Search Client Code, Client Name, Client Phone No, RM Name or RM Phone No"
                placeholder="Search Client Code, Client Name, Client Phone No, RM Name or RM Phone No"
                charCount={charCount}
                fullWidth={false}
                sx={{ width: { xs: "100%", md: 600 } }}
              />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <AppDatePicker
              value={filters.updatedDate ? dayjs(filters.updatedDate) : null}
              onChange={(newValue) =>
                setFilters((prev) => ({ ...prev, updatedDate: newValue ? newValue.format("YYYY-MM-DD") : "" }))
              }
              placeholder="Updated Date"
              fullWidth={false}
              sx={{ width: 170 }}
              />
            </LocalizationProvider>
            </Box>
            <CustomersTable
              searchInput={searchValue}
              filters={filters}
              handleEditClick={(e, data) => handlePopupOpen("Edit", data)}
              onViewClient={handleViewClient}
            />
            <CustomersFormDialog
              modalState={clientModal}
              handleModalState={handleModalChanges}
              selectedClient={selectedClient}
            />
          </>
        ) : (
          <>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <BackButton onClick={handleBackToTable}/>
            </Box>
            <ClientDetails clientCode={selectedClientCode} />
          </>
        )}
      </Container>
    </div>
  );
};

export default CustomersHome;